import React from 'react';
import Hero from '@/components/home/Hero';
import Features from '@/components/home/Features';
import HowItWorks from '@/components/home/HowItWorks';
import DownloadSection from '@/components/home/DownloadSection';
import FAQ from '@/components/home/FAQ';

const Home: React.FC = () => {
  return (
    <main>
      <Hero />
      <Features />
      <HowItWorks />
      <DownloadSection />
      <FAQ />
    </main>
  );
};

export default Home;
